import { Picture, Text, Link } from '../../components/index.js'
import { cn, getLocalizedPath } from '../../helpers/utils.js'
import { useAiuiContext } from '../AiuiProvider/index.js'

/**
 * 资源位项组件 - 桌面端
 */
export const ResourceItem = ({ resource }: { resource: any }) => {
  const { locale = 'us' } = useAiuiContext()
  return (
    <div className="laptop:h-[280px] desktop:h-[224px] lg-desktop:h-[280px] tablet:max-w-none desktop:w-full relative h-[240px] max-w-[358px] overflow-hidden">
      <Link href={getLocalizedPath(resource?.href, locale)} className="no-underline hover:text-current">
        <div className="relative h-full overflow-hidden [&_img]:hover:scale-110 [&_img]:hover:transition-all [&_img]:hover:duration-500">
          <Picture
            source={resource.imageUrl}
            width={404}
            height={280}
            className="size-full"
            imgClassName="object-cover h-full hover:scale-105 transition-all duration-300"
          />
          <div className="absolute inset-x-0 bottom-0 p-4">
            <Text
              as="p"
              html={resource?.title}
              className={cn('text-xl font-bold leading-[1.2]', {
                'text-white': resource?.theme !== 'dark',
                'text-black': resource?.theme === 'dark',
              })}
            />
            {resource?.desc && (
              <Text
                html={resource?.desc}
                className={cn('text-sm font-bold leading-[1.4]', {
                  'text-white': resource?.theme !== 'dark',
                  'text-black': resource?.theme === 'dark',
                })}
              />
            )}
          </div>
        </div>
      </Link>
    </div>
  )
}

/**
 * 资源位子分类标题组件 - 移动端
 */
export const ResourceSubSubCategoryItemComp = ({
  matchResourcesMetadata,
  onSubSubCategoryItemClick,
  expanded,
}: {
  matchResourcesMetadata: any
  onSubSubCategoryItemClick?: () => void
  expanded?: boolean
}) => {
  const content = (
    <>
      {matchResourcesMetadata?.label && (
        <Text html={matchResourcesMetadata?.label} className="text-sm font-bold leading-[1.4]" />
      )}
      {onSubSubCategoryItemClick && (
        <svg
          className={cn('size-5', {
            ['rotate-180']: expanded,
          })}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M6.91009 4.41009C7.23553 4.08466 7.76304 4.08466 8.08848 4.41009L13.0885 9.41009C13.4139 9.73553 13.4139 10.263 13.0885 10.5885L8.08848 15.5885C7.76304 15.9139 7.23553 15.9139 6.91009 15.5885C6.58466 15.263 6.58466 14.7355 6.91009 14.4101L11.3209 9.99929L6.91009 5.58848C6.58466 5.26304 6.58466 4.73553 6.91009 4.41009Z"
            fill="#080A0F"
          />
        </svg>
      )}
    </>
  )

  return onSubSubCategoryItemClick ? (
    <button
      className="flex w-full cursor-pointer items-center justify-between border-0 bg-transparent py-4 text-left"
      onClick={onSubSubCategoryItemClick}
      aria-expanded={expanded}
    >
      {content}
    </button>
  ) : (
    <div className="flex items-center justify-between py-4">{content}</div>
  )
}

/**
 * 资源位子分类内容组件 - 移动端
 */
export const ResourceSubSubCategoryContentComp = ({ matchResourcesMetadata }: { matchResourcesMetadata: any }) => {
  const { locale = 'us' } = useAiuiContext()
  return (
    <div className="tablet:grid tablet:grid-cols-2 flex grid-cols-1 flex-col gap-4">
      {!!matchResourcesMetadata?.resources?.length &&
        matchResourcesMetadata?.resources?.map((resourceItem: any, rIndex: number) => (
          <Link
            key={`resourceItem-${rIndex}`}
            href={getLocalizedPath(resourceItem?.href, locale)}
            className="no-underline hover:text-current"
          >
            <div className="laptop:h-[280px] tablet:max-w-none relative h-[240px] max-w-[358px]">
              <div className="relative h-full overflow-hidden">
                <Picture
                  source={resourceItem.imageUrl}
                  width={404}
                  height={280}
                  className="size-full"
                  imgClassName="object-cover h-full hover:scale-105 transition-all duration-300"
                />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <Text
                    html={resourceItem?.title}
                    as="p"
                    className={cn('text-xl font-bold leading-[1.2]', {
                      'text-white': resourceItem?.theme !== 'dark',
                      'text-black': resourceItem?.theme === 'dark',
                    })}
                  />
                  {resourceItem?.desc && (
                    <Text
                      html={resourceItem?.desc}
                      className={cn('text-sm font-bold leading-[1.4]', {
                        'text-white': resourceItem?.theme !== 'dark',
                        'text-black': resourceItem?.theme === 'dark',
                      })}
                    />
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
    </div>
  )
}
